import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Skeleton,
  TableHead,
  TableHeader,
} from "@pushpress/pushpress-ui";

export default function TableSkeleton() {
  return (
    <Table className="tw-min-w-full tw-divide-y tw-divide-neutral-300">
      <TableHeader>
        <TableRow>
          <TableHead className="tw-bg-neutral-50 tw-w-12 tw-px-5 tw-h-[55px]">
            <Skeleton className="tw-h-4 tw-w-4" />
          </TableHead>
          <TableHead className="tw-bg-neutral-50 tw-w-[30%] tw-h-[55px] max-sm:tw-hidden">
            <Skeleton className="tw-h-4 tw-w-12" />
          </TableHead>
          <TableHead className="tw-bg-neutral-50 tw-h-[55px] max-sm:tw-hidden">
            <Skeleton className="tw-h-4 tw-w-12" />
          </TableHead>
          <TableHead className="tw-bg-neutral-50 tw-h-[55px] max-sm:tw-hidden">
            <Skeleton className="tw-h-4 tw-w-12" />
          </TableHead>
          <TableHead className="tw-bg-neutral-50 tw-h-[55px] max-sm:tw-hidden">
            <Skeleton className="tw-h-4 tw-w-12" />
          </TableHead>
          <TableHead className="tw-bg-neutral-50 tw-h-[55px] max-sm:tw-hidden">
            <Skeleton className="tw-h-4 tw-w-12" />
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody className="tw-divide-y tw-divide-neutral-200 tw-bg-white">
        {[...Array(10)].map((_, index) => (
          <TableRow key={index}>
            <TableCell className="tw-px-7 sm:tw-w-12 sm:tw-px-6 tw-py-2">
              <Skeleton className="tw-h-4 tw-w-4" />
            </TableCell>
            <TableCell className="tw-py-2 tw-pl-3 tw-pr-4 tw-text-sm sm:tw-pl-0 tw-w-[30%]">
              <div className="tw-flex tw-items-center tw-space-x-4">
                <Skeleton className="tw-h-11 tw-w-11 !tw-rounded-full" />
                <div className="tw-space-y-2">
                  <Skeleton className="tw-h-4 tw-w-32" />
                  <Skeleton className="tw-mt-1 tw-h-3 tw-w-48" />
                  {/* Mobile content */}
                  <div className="tw-break-words sm:tw-hidden tw-text-xs tw-mt-1">
                    <Skeleton className="tw-h-3 tw-w-24" />
                  </div>
                  <div className="sm:tw-hidden tw-flex tw-gap-2 tw-mt-2">
                    <Skeleton className="tw-h-5 tw-w-16 !tw-rounded-full" />
                    <Skeleton className="tw-h-5 tw-w-16 !tw-rounded-full" />
                  </div>
                </div>
              </div>
            </TableCell>
            <TableCell className="tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-sm max-sm:tw-hidden">
              <Skeleton className="tw-h-4 tw-w-16" />
            </TableCell>
            <TableCell className="tw-px-3 tw-py-2 tw-text-sm tw-w-[20%] max-sm:tw-hidden">
              <Skeleton className="tw-h-4 tw-w-24" />
            </TableCell>
            <TableCell className="tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-sm max-sm:tw-hidden">
              <Skeleton className="tw-h-4 tw-w-20" />
            </TableCell>
            <TableCell className="tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-sm max-sm:tw-hidden">
              <Skeleton className="tw-h-4 tw-w-28" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
